/**
 * Get List
 */
export const WEB_JOURNAL_CATEGORY_LIST = "common/WEB_JOURNAL_CATEGORY_LIST";
export const WEB_JOURNAL_CATEGORY_LIST_SUCCESS = "common/WEB_JOURNAL_CATEGORY_LIST_SUCCESS";
export const WEB_JOURNAL_CATEGORY_LIST_FAILURE = "common/WEB_JOURNAL_CATEGORY_LIST_FAILURE";
